import { render } from "./AddBeneficiaryAlternative.vue?vue&type=template&id=b9acc500&ts=true"
import script from "./AddBeneficiaryAlternative.vue?vue&type=script&lang=ts"
export * from "./AddBeneficiaryAlternative.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__